import { useState } from 'react';
import CountUp from 'react-countup';
import personne from '../../images/icons/icon12.png';
import mairies from '../../images/icons/refresh.png';
import usine from '../../images/icons/icon14.png';
import eau from '../../images/icons/icon15.png';

import { ScrollCounter } from '../../lib/scrollView';

export interface StatisticHomeSectionProps {
  className?: string;
  img1?: string;
  img2?: string;
  img3?: string;
  img4?: string;
  title1?: string;
  title2?: string;
  title3?: string;
  title4?: string;
  val1?: string;
  val2?: number;
  val3?: number;
  val4?: number;
}

const StatisticHomeSection: React.FC<StatisticHomeSectionProps> = ({
  className,
  img1 = personne,
  img2 = mairies,
  img3 = usine,
  img4 = eau,
  title1 = 'communes adhérentes',
  title2 = 'd’eau assainie par an',
  title3 = 'réseau de collecte',
  title4 = 'stations d’épuration',
  val1 = '31',
  val2 = 17,
  val3 = 252,
  val4 = 2,
}) => {
  const [counterOn, setCounterOn] = useState(false);

  const handleScrollTrigger = () => {
    setCounterOn(true);
  };

  return (
    <>
      <ScrollCounter onScrollCounter={handleScrollTrigger} />
      <div
        className={`relative p-12 bg-[#f0fafe] ${className} `}
        style={{
          zIndex: 0,
        }}
      >
        <div className={`text-3xl font-bold text-center text-black`}>Nos chiffres clés</div>

        <div className="flex flex-col items-center justify-center m-5 md:space-x-6 xl:flex-row">
          <div className="text-white">
            {' '}
            <div className={`flex flex-col   items-center      `}>
              <div className="items-center gap-[12px] inline-flex flex-col relative flex-[0_0_auto]">
                <div
                  className="w-[65px] h-[65px] bg-primary"
                  style={{
                    mask: `url(${img1}) no-repeat center`,
                    maskSize: 'contain',
                    WebkitMask: `url(${img1}) no-repeat center`,
                    WebkitMaskSize: 'contain',
                  }}
                />
                <div
                  className={`w-fit font-bold text-black  text-[40px] text-center whitespace-nowrap relative   tracking-[0] leading-[normal]`}
                >
                  {val1 === '31' ? (
                    <>{counterOn && <CountUp start={0} end={31} duration={5} />}</>
                  ) : (
                    val1 === '92%' && (
                      <>
                        {'>'}
                        {counterOn && <CountUp start={0} end={92} duration={5} />}
                        {'%'}
                      </>
                    )
                  )}
                </div>
              </div>
              <div className="relative w-[254px]   font-bold text-[#e3e3e3] text-[13px] text-center tracking-[0] leading-[normal]">
                <div className={` text-center text-primary whitespace-nowrap`}>{title1}</div>
              </div>
            </div>
          </div>
          <div
            className={`lg:flex flex-col hidden md:hidden   items-center gap-[17px]  lg:h-48 md:border-r   lg:[border-right-style:solid] text-primary`}
          ></div>
          <div className="text-white">
            {' '}
            <div className={`flex flex-col mt-14 lg:mt-0  items-center      `}>
              <div className="items-center gap-[12px] inline-flex flex-col relative flex-[0_0_auto]">
                <div
                  className="w-[65px] h-[65px] bg-primary"
                  style={{
                    mask: `url(${img2}) no-repeat center`,
                    maskSize: 'contain',
                    WebkitMask: `url(${img2}) no-repeat center`,
                    WebkitMaskSize: 'contain',
                  }}
                />
                <div
                  className={`w-full font-bold text-black  text-[40px] text-center whitespace-nowrap relative  tracking-[0] leading-[normal]`}
                >
                  {counterOn && <CountUp start={0} end={val2} duration={1} />} Mm³
                </div>
              </div>
              <div className="relative w-[254px]   font-bold text-[#e3e3e3] text-[13px] text-center tracking-[0] leading-[normal]">
                <div className={` text-center text-primary whitespace-nowrap`}>{title2}</div>
              </div>
            </div>
          </div>

          <div
            className={`lg:flex flex-col hidden md:hidden   items-center gap-[17px]  lg:h-48 md:border-r   lg:[border-right-style:solid] text-primary `}
          ></div>

          <div className={`flex flex-col mt-14 lg:mt-0   items-center       `}>
            <div className="items-center gap-[12px] inline-flex flex-col relative flex-[0_0_auto]">
              <div
                className="w-[65px] h-[65px] bg-primary"
                style={{
                  mask: `url(${img3}) no-repeat center`,
                  maskSize: 'contain',
                  WebkitMask: `url(${img3}) no-repeat center`,
                  WebkitMaskSize: 'contain',
                }}
              />
              <div
                className={`w-fit font-bold text-black }  text-[40px] text-center whitespace-nowrap relative   tracking-[0] leading-[normal]`}
              >
                {title3 === "Usine de production d'eau" ? (
                  <>{counterOn && <CountUp start={0} end={val3} duration={5} />}</>
                ) : (
                  <>
                    {counterOn && <CountUp start={0} end={val3} duration={5} />}
                    {'Km'}
                  </>
                )}
              </div>
            </div>
            <div className="relative w-[254px]   font-bold text-[#e3e3e3] text-[13px] text-center tracking-[0] leading-[normal]">
              <div className={` text-center text-primary `}>{title3}</div>
            </div>
          </div>

          <div
            className={`lg:flex flex-col hidden md:hidden   items-center gap-[17px]  lg:h-48 md:border-r   lg:[border-right-style:solid] text-primary `}
          ></div>

          <div className={`flex flex-col mt-14 lg:mt-0   items-center       `}>
            <div className="items-center gap-[12px] inline-flex flex-col   flex-[0_0_auto]">
              <div
                className="w-[65px] h-[65px] bg-primary"
                style={{
                  mask: `url(${img4}) no-repeat center`,
                  maskSize: 'contain',
                  WebkitMask: `url(${img4}) no-repeat center`,
                  WebkitMaskSize: 'contain',
                }}
              />
              <div
                className={`w-fit font-bold text-black }  text-[40px] text-center whitespace-nowrap relative   tracking-[0] leading-[normal]`}
              >
                {title4 === 'de m³ distribués par an' ? (
                  <>{counterOn && <CountUp start={0} end={val4} duration={5} />}M</>
                ) : (
                  <>{counterOn && <CountUp start={0} end={val4} duration={5} />}</>
                )}
              </div>
            </div>
            <div className="relative w-[254px]   font-bold text-[#e3e3e3] text-[13px] text-center tracking-[0] leading-[normal]">
              <div className={` text-center text-primary `}>{title4}</div>
            </div>
          </div>
          <div
            className={`lg:flex flex-col hidden md:hidden   items-center gap-[17px]  lg:h-48 md:border-r   lg:[border-right-style:solid] text-primary `}
          ></div>
        </div>
      </div>
    </>
  );
};

export default StatisticHomeSection;
